import React, { forwardRef, useEffect } from "react";
import { Form, InputNumber, Switch } from "antd";

import { MdOutlineAttachMoney } from "react-icons/md";

const ProductPrice = forwardRef((props, ref) => {
  const [form] = Form.useForm();

  const { productItem } = props;

  const valueForm = {
    originalPrice: 0,
    price: 0,
    salePrice: 0,
    displaySalePrice: false,
  };

  useEffect(() => {
    if (productItem) {
      form.setFieldsValue({
        originalPrice: productItem.originalPrice,
        price: productItem.price,
        salePrice: productItem.salePrice,
        displaySalePrice: productItem.displaySalePrice,
      });
    } else {
      form.setFieldsValue(valueForm);
    }
  }, [form]);

  const onFinishFailed = (errorInfo) => {
    props.onFinishFailed({
      errorFields: errorInfo.errorFields,
      name: "ProductPrice",
    });
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    console.log(values);
    props.onSubmit(values, "ProductPrice");
  };

  return (
    <>
      <Form
        form={form}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 14,
        }}
        ref={ref}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="horizontal"
        size="large"
      >
        <Form.Item
          label="Giá gốc"
          name="originalPrice"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập giá thực!",
            },
          ]}
        >
          <InputNumber
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            addonAfter={<MdOutlineAttachMoney />}
          />
        </Form.Item>

        <Form.Item
          label="Giá bán"
          name="price"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập giá bán!",
            },
          ]}
        >
          <InputNumber
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            addonAfter={<MdOutlineAttachMoney />}
          />
        </Form.Item>

        <Form.Item label="Giá khuyến mãi" name="salePrice">
          <InputNumber
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            addonAfter={<MdOutlineAttachMoney />}
          />
        </Form.Item>

        <Form.Item
          label="Vô hiệu hóa nút mua"
          valuePropName="checked"
          name="displaySalePrice"
        >
          <Switch />
        </Form.Item>
      </Form>
    </>
  );
});

export default ProductPrice;
